import { render, staticRenderFns } from "./OnboardingAppointmentRequestPage.vue?vue&type=template&id=097fc1ef&scoped=true&"
import script from "./OnboardingAppointmentRequestPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAppointmentRequestPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingAppointmentRequestPage.vue?vue&type=style&index=0&id=097fc1ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097fc1ef",
  null
  
)

export default component.exports